module.exports = __webpack_public_path__ + "static/media/dermalogica-logo.fb98ba70.svg";